
import useDialogVisible from '@/hooks/use-dialog-visible';
import { defineComponent, PropType, reactive, ref } from 'vue';
import { IManageUpdateBatchPMReq, serviceBasicInfoRes } from '@/api/project-service/type.d';
import { HANDLE_SERVICE_TYPE_LIST, FIRST_PEOPLE_ENUM } from '@/constant/project-service/index';
import { ElMessage, ElForm } from 'element-plus';
import { bulkEdit,
  // matchBackendPerson,
  manageSelectAllServiceBasicInfo } from '@/api/project-service/index';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { useFuzzy } from '@/hooks/use-fuzzy';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';

export interface IManageUpdateBatchPMReqExtend extends IManageUpdateBatchPMReq {
  firstHeadOfBackend: string;
  secondHeadOfBackend: string;
}
export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    ids: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'success'],
  setup(props, { emit }) {
    const { visible } = useDialogVisible(props, emit);
    const formRef = ref< typeof ElForm>();
    const servicesList = ref<serviceBasicInfoRes>({} as serviceBasicInfoRes);
    const formData = reactive<IManageUpdateBatchPMReqExtend>({
      serviceType: '',
      serviceName: '',
      headOfDevelopment: '',
      secondHeadOfDevelopment: '',
      headOfTest: '',
      secondHeadOfTest: '',
      firstHeadOfBackend: '',
      secondHeadOfBackend: '',
    });

    // 模糊输入负责人名字
    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });
    const handleChangeUser = (userInfo: UserItem, key:FIRST_PEOPLE_ENUM) => {
      switch (key) {
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST:
          formData.headOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.headOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND:
          formData.secondHeadOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.secondHeadOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_FIRST:
          formData.headOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.headOfTest = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_SECOND:
          formData.secondHeadOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.secondHeadOfTest = '';
          }
          break;
        default: break;
      }
    };
    // const handleChangeHeadOfDevelopmentUser = (userInfo: UserItem) => {
    //   formData.headOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
    //   if (userInfo.name === undefined || userInfo.bbCode === undefined) {
    //     formData.headOfDevelopment = '';
    //   }
    // };
    // const handleChangeSecondHeadOfDevelopmentUser = (userInfo: UserItem) => {
    //   formData.secondHeadOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
    //   if (userInfo.name === undefined || userInfo.bbCode === undefined) {
    //     formData.secondHeadOfDevelopment = '';
    //   }
    // };
    // const handleChangeHeadOfTestUser = (userInfo: UserItem) => {
    //   formData.headOfTest = `${userInfo.name}(${userInfo.bbCode})`;
    //   if (userInfo.name === undefined || userInfo.bbCode === undefined) {
    //     formData.headOfTest = '';
    //   }
    // };
    // const handleChangeSecondHeadOfTestUser = (userInfo: UserItem) => {
    //   formData.secondHeadOfTest = `${userInfo.name}(${userInfo.bbCode})`;
    //   if (userInfo.name === undefined || userInfo.bbCode === undefined) {
    //     formData.secondHeadOfTest = '';
    //   }
    // };
    // 重置表单
    const resetVar = () => {
      formData.serviceName = '';
      formData.serviceType = '';
      formRef.value?.resetFields();
      formRef.value?.clearValidate();
    };
    const handleOpen = () => {
      resetVar();
    };
    // 查询后端服务
    const handleSearchService = async () => {
      const { data } = await manageSelectAllServiceBasicInfo();
      if (!data) {
        servicesList.value = [];
        return;
      }
      servicesList.value = data;
    };
    // 处理选中的后端服务，回显对应后端负责人
    const handleSelectServiceItem = (val: any) => {
      const res = servicesList.value.filter((item) => {
        return item.serviceName === val;
      });
      formData.firstHeadOfBackend = `${res[0]?.firstHeadOfBackend}(${res[0]?.firstHeadOfBackendCode})`;
      formData.secondHeadOfBackend = `${res[0]?.secondHeadOfBackend}(${res[0]?.secondHeadOfBackendCode})`;
      if (res[0]?.firstHeadOfBackend === '') {
        formData.firstHeadOfBackend = '';
      }
      if (res[0]?.secondHeadOfBackend === '') {
        formData.secondHeadOfBackend = '';
      }
    };
    const handleClear = () => {
      formData.secondHeadOfBackend = '';
      formData.firstHeadOfBackend = '';
    };
    // 根据后端服务匹配后端负责人
    // const matchService = async () => {
    //   if (formData.serviceName) {
    //     const { data } = await matchBackendPerson(formData.serviceName);
    //     formData.firstHeadOfBackend = data?.firstHeadOfBackend || '';
    //     formData.secondHeadOfBackend = data?.secondHeadOfBackend || '';
    //   }
    // };
    const handleConfirm = async () => {
      const requestParamValues = Object.values(formData);
      if (requestParamValues.every(item => item === '')) {
        ElMessage.error('请至少编辑一条信息');
      } else {
        formData.ids = props.ids;
        console.log(formData);
        await bulkEdit(formData);
        ElMessage.success('操作成功');
        resetVar();
        emit('success');
        visible.value = false;
      }
    };
    const { visible: showBulkEditDialogVisible } = useDialogVisible(props, emit);

    return {
      showBulkEditDialogVisible,
      formData,
      formRef,
      HANDLE_SERVICE_TYPE_LIST,
      FIRST_PEOPLE_ENUM,
      handleChangeUser,
      handleConfirm,
      visible,
      handleOpen,
      resetVar,
      // matchService,
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
      // handleChangeHeadOfDevelopmentUser,
      // handleChangeSecondHeadOfDevelopmentUser,
      // handleChangeHeadOfTestUser,
      // handleChangeSecondHeadOfTestUser,
      handleSearchService,
      handleSelectServiceItem,
      servicesList,
      handleClear,
    };
  },

});
